module.exports = __webpack_public_path__ + "media/images/flags/4x3/omn-cf72330b6fe1017e0836cb4aa03c389f.svg";